import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';
import useWalletActions from './useWalletActions';

export default function useWalletConnector() {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { data: session, status } = useSession();
    //--------------------------------------
    const { walletStore, checkSessionAndConnectIfNeeded } = useWalletActions();
    //--------------------------------------
    useEffect(() => {
        if (status === 'authenticated') {
            console.log(`[WalletConnector] - Session authenticated, might trigger a wallet connection... (status: ${status})`);
            checkSessionAndConnectIfNeeded();
        } else if (status === 'unauthenticated') {
            console.log(`[WalletConnector] - No Session`);
        } else if (status === 'loading') {
            console.log(`[WalletConnector] - Loading Session`);
        }
    }, [status]);
    //--------------------------------------
    return {
        isRefreshing,
        walletStore,
    };
    //--------------------------------------
}
